import { FormattedMessage } from 'react-intl';

import { Button } from '@xing-com/button';

import type { ProductType } from '../../typings/types';
import useCustomLink from '../hooks/use-custom-link';

import {
  StyledHero,
  ButtonWrapper,
  StyledIconArrowRight,
} from './product-cta.styles';

interface ProductCtaProps {
  product: ProductType;
}

export const ProductCta: React.FC<ProductCtaProps> = ({ product }) => {
  const link = useCustomLink(product);

  return (
    <div>
      <StyledHero size="medium" sizeConfined="large">
        <FormattedMessage
          id={`UPSELL_LOGGED_OUT_PAGE_HEADER_${product.toUpperCase()}_PRODUCT_HEADLINE`}
        />
      </StyledHero>
      <ButtonWrapper>
        <StyledIconArrowRight width={32} />
        <Button
          size="small"
          sizeConfined="medium"
          variant={product === 'premium' ? 'premium' : 'proJobs'}
          to={link}
        >
          <FormattedMessage
            id={`UPSELL_LOGGED_OUT_PAGE_HEADER_${product.toUpperCase()}_PRODUCT_CTA`}
          />
        </Button>
      </ButtonWrapper>
    </div>
  );
};
